import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeDocument extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            locale: props.locale,
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`object-container`}>
                <div className={`prototype document-panel file `}>
                    <div className="flex-item">
                        <div className="document-header">
                            <div className={`link-title file complete`}>
                                <span className="title" dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_DOCUMENT_TITLE}}/>
                            </div>
                        </div>
                        <div className="document-description" dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_DOCUMENT_TEXT}}/>

                    </div>

                </div>
            </div>
        );
    }
}

PrototypeDocument.propTypes = {
    locale: PropTypes.object,
};

PrototypeDocument.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeDocument);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeDocument.js
 **/